import { useState } from "react";
import Reveal from "@/pages/home/components/Reveal";
import SectionTitle from "@/pages/home/components/SectionTitle";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="常见问题"
            title="还有这几件事，一次说清"
            align="center"
            desc="把大家问得最多的问题整理在一起，省去你再翻一遍的功夫。"
          />
        </Reveal>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = open === index;
            return (
              <Reveal key={item.q} delay={index * 55}>
                <div className="overflow-hidden rounded-xl border border-background-200/80 bg-background-100/60">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span className="font-heading text-sm font-bold text-primary-600">
                        Q{String(index + 1).padStart(2, "0")}
                      </span>
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                    </span>
                    <i
                      className={`ri-arrow-down-s-line shrink-0 text-lg text-foreground-500 transition-transform ${
                        isOpen ? "rotate-180" : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}